import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-slider-item-boxer.js';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="title-card" data-show="false" class="card-title" style="display: none;"></div>
    <div
      class="wrap-items"
      data-attribute="wrap-items"
      data-col-per-view="3"
      data-space-between="30px"
      data-item-background="#eff3fa"
      data-item-border-radius="10"
      data-color-star="#FFD700"
      style="--item-background: #eff3fa; --item-border-radius: 10px; --color-star: #FFD700;"
    >
      <div class="swiper">
        <div data-attribute="list-item" class="swiper-wrapper">
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
              <div class="wrap-img">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f9784a7e1bf6be7580e2.png"
                  alt=""
                />
              </div>
              <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-attribute="description-item" data-show="true" class="description-item">
                <p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
              <div class="wrap-img">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f97c9ca8fc716a155d6f.png"
                  alt=""
                />
              </div>
              <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-attribute="description-item" data-show="true" class="description-item">
                <p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
              <div class="wrap-img">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f97fa061ddf10fa4fcc6.png"
                  alt=""
                />
              </div>
              <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-attribute="description-item" data-show="true" class="description-item">
                <p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
              <div class="wrap-img">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f97fa061ddf10fa4fcc6.png"
                  alt=""
                />
              </div>
              <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-attribute="description-item" data-show="true" class="description-item">
                <p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
              <div class="wrap-img">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f97fa061ddf10fa4fcc6.png"
                  alt=""
                />
              </div>
              <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <title>star</title>
                  <path
                    d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-attribute="description-item" data-show="true" class="description-item">
                <p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
